import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-2"
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = {
  key: 1,
  class: "card"
}
const _hoisted_6 = { class: "card-header d-flex justify-content-between align-items-center flex-wrap" }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "card-body p-0" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table table-sm table-striped table-bordered table-hover mb-0" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = ["onUpdate:modelValue", "disabled"]
const _hoisted_14 = { class: "text-end text-nowrap" }
const _hoisted_15 = { class: "text-nowrap" }
const _hoisted_16 = { class: "card-footer" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-12" }
const _hoisted_19 = {
  key: 2,
  class: "card mt-2"
}
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = { class: "mb-0" }

import { reactive, computed } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import * as service from "@/services/BoletosService";
import { fdata, f2dec } from "@/utils/funcoes";


export default /*@__PURE__*/_defineComponent({
  __name: 'ImportarRelatorioBanco',
  setup(__props) {

const controle = reactive({
  arquivo: null as File | null,
  itens: [] as service.ImpRelBancoItemDTO[],
  selecionados: {} as Record<number, boolean>,
  importado: false,
  resultadoAplicacao: [] as string[],
  status: "",
  erro: "",
});

const totalSelecionados = computed(() => Object.values(controle.selecionados).filter(v => v).length);

function onFileChange(event: Event) {
  const target = event.target as HTMLInputElement;
  controle.arquivo = target.files && target.files.length > 0 ? target.files[0] : null;
}

function importar() {
  if (!controle.arquivo) {
    controle.erro = "Selecione um arquivo!";
    return;
  }

  controle.status = "Importando...";
  controle.erro = "";
  controle.resultadoAplicacao = [];

  service.importarRelatorioBanco(controle.arquivo)
    .then((r) => {
      controle.itens = r;
      controle.selecionados = {};
      r.forEach((item, idx) => {
        controle.selecionados[idx] = item.podeAplicar;
      });
      controle.importado = true;
      controle.status = "";

      if (r.length === 0) {
        controle.erro = "Nenhuma linha encontrada no arquivo.";
      }
    })
    .catch((erro) => {
      controle.erro = erro.message || erro;
      controle.status = "";
    });
}

function marcarTodos(valor: boolean) {
  controle.itens.forEach((item, idx) => {
    if (item.podeAplicar) controle.selecionados[idx] = valor;
  });
}

function aplicar() {
  const escolhidos = controle.itens
    .map((item, idx) => ({ item, idx }))
    .filter(({ item, idx }) => controle.selecionados[idx] && item.podeAplicar && item.boletoId != null)
    .map(({ item }) => ({
      boletoId: item.boletoId as number,
      tipo: item.tipo,
      valor: item.valor,
      valorCobrado: item.valorCobrado,
      dataLiquidacao: item.dataLiquidacao,
    } as service.ImpRelBancoAplicarDTO));

  if (escolhidos.length === 0) {
    controle.erro = "Nenhum item selecionado!";
    return;
  }

  controle.status = `Aplicando ${escolhidos.length} item(ns)...`;
  controle.erro = "";

  service.aplicarRelatorioBanco(escolhidos)
    .then((r) => {
      controle.resultadoAplicacao = r;
      controle.status = "";
      controle.itens = [];
      controle.importado = false;
      controle.arquivo = null;
    })
    .catch((erro) => {
      controle.erro = erro.message || erro;
      controle.status = "";
    });
}

function cancelar() {
  controle.importado = false;
  controle.itens = [];
  controle.selecionados = {};
}

function descricaoTipo(tipo: string | undefined) {
  if (tipo === "Liquidados") return "Liquidados (pagos)";
  if (tipo === "Baixados") return "Baixados";
  if (tipo === "Vencidos") return "Vencidos (informativo)";
  return tipo ?? "";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Importar Relatório do Banco",
      items: [
    { label: 'Cobrança', to: '/boletos' },
    { label: 'Importar Relatório do Banco' }]
    }),
    _createVNode(Notificacao, {
      erro: controle.erro,
      onLimparErro: _cache[0] || (_cache[0] = ($event: any) => (controle.erro = '')),
      progresso: controle.status,
      onLimparProgresso: _cache[1] || (_cache[1] = ($event: any) => (controle.status = ''))
    }, null, 8, ["erro", "progresso"]),
    (!controle.importado)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-muted" }, " Importe a planilha (.xlsx) de Títulos exportada do portal do banco — Vencidos, Liquidados ou Baixados. O tipo do relatório é detectado automaticamente pelas colunas do arquivo. Depois de importar, você confere e escolhe quais boletos terão a ação aplicada antes de confirmar. ", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[7] || (_cache[7] = _createElementVNode("label", null, "Arquivo (.xlsx)", -1)),
                _createElementVNode("input", {
                  type: "file",
                  accept: ".xlsx",
                  class: "form-control form-control-sm",
                  onChange: onFileChange
                }, null, 32)
              ])
            ]),
            _createElementVNode("a", {
              class: "btn btn-primary btn-sm",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (importar()))
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("i", { class: "fa fa-upload me-1" }, null, -1),
              _createTextVNode(" Importar ", -1)
            ]))])
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.importado)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(controle.itens.length) + " registro(s) — " + _toDisplayString(descricaoTipo(controle.itens[0]?.tipo)), 1),
            _createElementVNode("div", null, [
              _createElementVNode("a", {
                class: "btn btn-sm btn-outline-secondary me-1",
                href: "#",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (marcarTodos(true)), ["prevent"]))
              }, "Marcar todos"),
              _createElementVNode("a", {
                class: "btn btn-sm btn-outline-secondary",
                href: "#",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (marcarTodos(false)), ["prevent"]))
              }, "Desmarcar todos")
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("table", _hoisted_10, [
                _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "text-center" }, "Aplicar?"),
                    _createElementVNode("th", null, "Nosso Número"),
                    _createElementVNode("th", null, "Pagador"),
                    _createElementVNode("th", { class: "text-end" }, "Valor"),
                    _createElementVNode("th", { class: "text-nowrap" }, "Vencimento"),
                    _createElementVNode("th", null, "Ação"),
                    _createElementVNode("th", null, "Status Atual")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (controle.itens.length == 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [...(_cache[10] || (_cache[10] = [
                        _createElementVNode("td", {
                          colspan: "7",
                          class: "text-center"
                        }, "Nenhum registro encontrado", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.itens, (item, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: idx,
                      class: _normalizeClass({ 'table-secondary': !item.podeAplicar })
                    }, [
                      _createElementVNode("td", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((controle.selecionados[idx]) = $event),
                          disabled: !item.podeAplicar
                        }, null, 8, _hoisted_13), [
                          [_vModelCheckbox, controle.selecionados[idx]]
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.nossoNumero), 1),
                      _createElementVNode("td", null, _toDisplayString(item.pagador), 1),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(f2dec)(item.tipo == 'Liquidados' ? (item.valorCobrado ?? item.valor) : item.valor)), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(fdata)(item.dataVencimento)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(item.boletoId == null ? 'text-danger' : (item.podeAplicar ? 'text-primary fw-bold' : 'text-muted'))
                        }, _toDisplayString(item.acaoProposta), 3)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.statusAtualDescricao ?? '-'), 1)
                    ], 2))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("a", {
                  class: "btn btn-sm btn-success me-1",
                  href: "#",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (aplicar()), ["prevent"]))
                }, [
                  _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fa fa-check me-1" }, null, -1)),
                  _createTextVNode(" Aplicar Selecionados (" + _toDisplayString(totalSelecionados.value) + ") ", 1)
                ]),
                _createElementVNode("a", {
                  class: "btn btn-sm btn-secondary",
                  href: "#",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (cancelar()), ["prevent"]))
                }, " Cancelar ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.resultadoAplicacao.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-header fw-bold" }, "Resultado da aplicação", -1)),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("ul", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.resultadoAplicacao, (linha, idx) => {
                return (_openBlock(), _createElementBlock("li", { key: idx }, _toDisplayString(linha), 1))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})